import { render, staticRenderFns } from "./CustomizeWebsite.vue?vue&type=template&id=5055a64c&"
import script from "./CustomizeWebsite.vue?vue&type=script&lang=js&"
export * from "./CustomizeWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports